import { humanReadableStatus, isApolloError } from "@qw/auth";
import type { FC } from "react";

import { Alert, AlertDescription } from "../alert";

interface AuthErrorProps {
  error: unknown;
}

export const AuthError: FC<AuthErrorProps> = ({ error }) => (
  <Alert variant="destructive" className="max-w-xs mb-4">
    <AlertDescription>{getErrorMessage(error)}</AlertDescription>
  </Alert>
);

function getErrorMessage(error: unknown): string {
  if (isApolloError(error)) {
    const { graphQLErrors, networkError, message } = error;

    // Return GraphQL error messages if present
    if (graphQLErrors.length > 0) {
      return graphQLErrors.map((err) => err.message).join(", ");
    }

    // Return network error with human-readable status if available
    if (networkError) {
      const statusCode = "statusCode" in networkError ? networkError.statusCode : undefined;
      return statusCode ? `${statusCode}: ${humanReadableStatus(statusCode)}` : networkError.message;
    }

    // Fallback to general message
    return message;
  }

  // Handle generic Error objects
  if (error instanceof Error) {
    return error.message;
  }

  // Fallback for unknown error types
  return "An unexpected error occurred";
}
